import { AppNameMappings, TAppName } from "@/types/common";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getCurrencySymbol = (currencyCode: number) => {
  switch (currencyCode) {
    case 398:
      return "₸";
  }
};

export const formatPrice = (price: number, locale: string) => {
  return price.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export const getProductPrice = (price: bigint, locale: string) => {
  const formattedPrice = formatPrice(Number(price) / 100, locale);
  return formattedPrice;
}

const normalizeAppName = (appName: TAppName) => {
  switch (appName) {
    case 'telecomkz':
      return AppNameMappings.TelecomKz;
    case 'aitu':
    default:
      return AppNameMappings.Aitu;
    case 'platonus':
      return AppNameMappings.Platonus;
  }
};

export const getAppName = () => {
  if (window) {
    const searchParams = new URLSearchParams(window.location.search);
    const appName = searchParams.get('app_name');
    if (appName) {
      const lowercased = appName.toLowerCase() as TAppName;
      return normalizeAppName(lowercased);
    }
  }
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Aitu")) {
    return "Aitu";
  }
  if (userAgent.includes("TelecomKz")) {
    return "TelecomKz";
  }
  if (userAgent.includes("Platonus")) {
    return "Platonus";
  }
  return "Aitu";
};

export const getPlatform = () => {
  if (navigator) {

    const userAgent = navigator.userAgent;
    if (userAgent.includes('iOS')) {
      return 'ios';
    }
    if (userAgent.includes('Android')) {
      return 'android';
    }
    return 'web';
  }
  return '';
}

export const getLangFromQuery = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get('lang');
  if (lang) {
    return lang;
  }
  return "";
}

